import { useEffect, useState } from 'react';

import { IonSkeletonText } from '@ionic/react';

import { Service } from '../../services/service';

interface ImageProps {
  className?: string;
  service: Service;
  token?: string;
  url: string;
}

export const Image = ({ url, token, service, className }: ImageProps) => {
  const [imageUrl, setImageUrl] = useState<string>(url);
  const [data, setData] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (url === service.defaultAvatar) {
      setImageUrl(url);
      setLoading(false);

      return;
    }

    const { useAuth, url: imageUrl } = service.getNonCloudAuthenticatedUrl(url);

    if (useAuth && token) {
      const headers = {
        Authorization: service.getAuthorizationHeader(token)
      };

      fetch(imageUrl, {
        method: 'get',
        headers: new Headers(headers),
        redirect: 'follow',
        mode: 'cors'
      })
        .then((response) => response.blob())
        .then((blob) => setData(URL.createObjectURL(blob)))
        .catch((error) => console.error('Error getting image', error));
    } else {
      setImageUrl(imageUrl);
    }

    setLoading(false);
  }, [url, token]);

  if (loading) {
    return (
      <IonSkeletonText className={className} animated={true}></IonSkeletonText>
    );
  }

  return <img className={className} src={data ?? imageUrl} />;
};
